import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '../KeyComponents';

function DropdownItem(props) {
  const {
    icon,
    label,
    sublabel,
    name,
    value,
    description,
    className,
    size,
    onClick,
    ...other
  } = props;

  return (
    <ListItem
      icon={icon}
      label={label}
      sublabel={sublabel}
      description={description}
      className={className}
      size={size}
      onClick={onClick}
      {...other}
    />
  );
}

DropdownItem.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string,
  sublabel: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm']),
  onClick: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
};

DropdownItem.defaultProps = {
  size: 'sm',
  onClick: () => { },
  icon: null,
  label: '',
  sublabel: '',
  description: '',
  className: '',
  name: '',
};

export default DropdownItem;
